import React, { useContext } from 'react';
import { vehicleContext } from '../VehicleProvider';
// import 'react-loading-skeleton/dist/skeleton.css';
import PricingBar from '../PricingBar/PricingBar';
import { priceContext } from '../PriceConfigProvider';
import { CTAContext } from '../CTAProvider';
import useStaticVehicleData from '../../hooks/useStaticVehicleData';

const ContentWrapper: React.FC = () => {
  const { vehicle, loading, isTier3, market } = useContext(vehicleContext);
  const priceConfigModel = useContext(priceContext);
  const { tier3Ctas } = useContext(CTAContext);

  const modelId = vehicle?.carline?.id ?? '';

  const staticVehicle = useStaticVehicleData(modelId);

  const rapidName = staticVehicle ?? '';

  if (!vehicle && !loading) return null;

  return (
    <PricingBar
      isTier3={isTier3}
      market={market}
      vehicle={vehicle}
      loading={loading}
      tier3Ctas={tier3Ctas}
      priceConfig={priceConfigModel}
      rapidName={rapidName}
    />
  );
};

export default ContentWrapper;
